import {
  Component,
  Input,
  ViewChildren,
  QueryList,
  OnInit,
  AfterViewInit,
} from "@angular/core";
import { RequisitoFormComponent } from "./requisito-form.component";
import { MatDialog } from "@angular/material/dialog";
import { ToastrComponent } from "../util/toastr/toastr.component";
import { Misc } from "../util/misc";
import { MatTable } from "@angular/material/table";
import { MetricaTipoAtividade } from "src/app/models/metrica.tipo.atividade.model";
import { MetricaTipo } from "src/app/models/metrica.tipo.model";
import { MetricaAtividade } from "src/app/models/metrica.atividade.model";
import { MetricaComplexidade } from "src/app/models/metrica.complexidade.model";
import { Requisito } from "src/app/models/requisito.model";
import { RequisitoService } from "src/app/services/requisito.service";
import { RequisitoMetricaService } from "src/app/services/requisito-metrica.service";
import { ValidacaoService } from "src/app/services/validacao.service";
import { UtilService } from "src/app/services/util.service";
import { MetricaService } from "src/app/services/metrica.service";
import { FaturamentoService } from "src/app/services/faturamento.service";
import { RequisitoMetrica } from "src/app/models/requisito-metrica.model";
import { EstimativaService } from "src/app/services/estimativa.service";
import { Router } from "@angular/router";
import * as constants from "src/app/models/constants/constants";
import { forkJoin } from "rxjs";
import { MetricaTipoAtividadeCliente } from "src/app/models/metrica.tipo.atividade.cliente.model";
import { Estimativa } from "src/app/models/estimativa.model";

@Component({
  selector: "app-requisito-main",
  templateUrl: "./requisito-main.component.html",
  styleUrls: ["./requisito-main.component.scss"],
})
export class RequisitoMainComponent implements OnInit {
  @ViewChildren(MatTable) tables: QueryList<MatTable<any>>;

  @Input() estimativaId: number;
  @Input() somenteLeitura: boolean = false;
  @Input() imprimindo: boolean = false;
  @Input() hiddenResume: boolean;

  metricaTipoAtividade: MetricaTipoAtividade[];
  metricaTipoAtividadeCliente: MetricaTipoAtividadeCliente[];

  metricaTipo: MetricaTipo[] = [];
  metricaAtividade: MetricaAtividade[] = [];
  metricaComplexidade: MetricaComplexidade[] = [];

  novaMetricaTipo: MetricaTipo;
  novaMetricaAtividade: MetricaAtividade;
  novaMetricaComplexidade: MetricaComplexidade;
  novaMetricaTipoAtividade: MetricaTipoAtividade;

  requisitos: Requisito[] = [];
  requisitosFiltrados: Requisito[] = [];
  displayedColumns: string[] = [
    "delete",
    "descricao",
    "tipo",
    "atividade",
    "complexidade",
    "quantidade",
    "horas",
    "salvar",
  ];

  message: string;
  requisitoInserindo: number = null;
  loading = true;

  listaFiltroTipo: MetricaTipo[] = [];
  listaFiltroAtividade: MetricaAtividade[] = [];
  listaFiltroComplexidade: MetricaComplexidade[] = [];

  filtroTipo: MetricaTipo;
  filtroAtividade: MetricaAtividade;
  filtroComplexidade: MetricaComplexidade;

  totalQuantidade = 0;
  totalHoras = 0;
  editarNomeReq: boolean;
  editarMetricaStatus: boolean;
  nomeRequisitoEditado: string;
  idAtual: number;
  tipoDelivery: boolean;
  estimativaTipo: number;
  perfilTipo: any;
  estimativaStatus: any;
  clicked = false;

  constructor(
    protected requisitoService: RequisitoService,
    protected requisitoMetricaService: RequisitoMetricaService,
    private toastr: ToastrComponent,
    private validacaoService: ValidacaoService,
    private estimativaService: EstimativaService,
    public utilService: UtilService,
    private router: Router,
    private metricaService: MetricaService,
    private faturamentoService: FaturamentoService,
    public misc: Misc,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.redirect();

    this.loading = true;

    this.estimativaService.getEstimativaTipo(this.estimativaId).subscribe(
      (estimativa: Estimativa) => {
        this.estimativaTipo = estimativa.estimativaTipoId;

        if (this.estimativaTipo == 3) {
          this.tipoDelivery = true;
          this.editarNomeReq = true;
          this.editarMetricaStatus = true;
        }

        if (this.estimativaStatus == constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
          this.somenteLeitura = true;
        }

        if (this.tipoDelivery && this.perfilTipo == constants.PerfilConstants.ID_PERFIL_DELIVERY) {
          this.somenteLeitura = false;
          this.hiddenResume;
        }

        this.editarNomeReq = false;
        this.editarMetricaStatus = false;

        this.carregarMetricaTipoAtividade(estimativa.projeto.clienteId);
      },
      (error) => {
        this.misc.processError(
          error,
          "Não foi possível carregar a lista de tipos."
        );

        this.loading = false;
      }
    );
  }

  ngAfterContentInit() {
    this.carregarRequisitoMetrica(this.estimativaId);
  }

  carregarMetricaTipoAtividade(clienteId: number) {
    let subscriptions: any = {};

    subscriptions.metricaTipoAtividade =
      this.metricaService.getMetricaTipoAtividade();
    subscriptions.metricaTipoAtividadeCliente =
      this.metricaService.getMetricaTipoAtividadePorCliente(clienteId);

    forkJoin(subscriptions).subscribe({
      next: (result: any) => {
        let metricaTipoAtividadeResult = result.metricaTipoAtividade.items;
        this.metricaTipoAtividadeCliente = result.metricaTipoAtividadeCliente.items;

        this.metricaTipoAtividade = metricaTipoAtividadeResult;

        this.metricaTipoAtividade = this.metricaTipoAtividade.filter(x => x.ativo == true);
        this.metricaTipoAtividade = this.metricaTipoAtividade.sort((a, b) => (a.metricaTipo.nome < b.metricaTipo.nome ? -1 : 1));

        this.atualizarMetricaTipoAtividadePorCliente(
          metricaTipoAtividadeResult,
          this.metricaTipoAtividadeCliente
        );

        this.metricaTipo = this.metricaTipoAtividade.map((item) => {
          return item.metricaTipo;
        });

        this.metricaTipo = this.metricaTipo.filter((value, index, self) => {
          const metricaTipo = self.find((p) => p.id === value.id);

          return self.indexOf(metricaTipo) === index;
        });

        this.carregarRequisitoMetrica(this.estimativaId);
      },
      error: (error) => {
        this.misc.processError(
          error,
          "Não foi possível carregar os dados da tela."
        );

        this.loading = false;
      },
    });
  }

  atualizarMetricaTipoAtividadePorCliente(listaMetricaTipoAtividade: MetricaTipoAtividade[], listaMetricaTipoAtividadeCliente: MetricaTipoAtividadeCliente[]) {
    listaMetricaTipoAtividadeCliente.forEach((metrica: MetricaTipoAtividadeCliente) => {
      let metricaTipoAtividade = listaMetricaTipoAtividade.find(p => p.id == metrica.idMetricaTipoAtividade);

      if (metricaTipoAtividade) {
        if (!metrica.ativo) {
          listaMetricaTipoAtividade.splice(listaMetricaTipoAtividade.indexOf(metricaTipoAtividade), 1);
        } else {
          metricaTipoAtividade.hora = metrica.hora;
        }
      } else {
        if (metrica.ativo) {
          listaMetricaTipoAtividade.push(metrica.idMetricaTipoAtividadeNavigation);
        }
      }
    });

    listaMetricaTipoAtividade = listaMetricaTipoAtividade.sort((a, b) => { return a.id - b.id });
  }

  redirect() {
    this.estimativaService
      .getEstimativaTipo(this.estimativaId)
      .subscribe((result: any) => {
        this.estimativaTipo = result.estimativaTipoId;
        this.estimativaStatus = result.statusId;

        const user = JSON.parse(localStorage.getItem("currentUserPricingWeb"));
        this.perfilTipo = user?.perfil?.[0]?.id;

        const isAdmin = this.perfilTipo === constants.PerfilConstants.ID_PERFIL_ADMINISTRADOR;
        const isDelivery = this.perfilTipo === constants.PerfilConstants.ID_PERFIL_DELIVERY;

        if (
          this.estimativaTipo === constants.TipoEstimativaConstants.ID_TIPO_ESTIMATIVA_PROJETO &&
          this.estimativaStatus === constants.EstimativaStatusConstants.ID_ESTIMATIVA_ELABORACAO &&
          isDelivery
        ) {
          this.router.navigate(["/access-denied"]);
        }
      });
  }


  criarNovo(requisito: Requisito) {
    requisito.requisitoMetrica.unshift({
      id: null,
      requisitoId: requisito.id,
      metricaTipoId: null,
      metricaAtividadeId: null,
      metricaComplexidadeId: null,
      descricao: "",
      hora: 0,
      qtde: 1,
      metricaAtividade: null,
      metricaComplexidade: null,
      metricaTipo: null,
      editarMetricaStatus: false,
      requisitoMetricaOriginal: null,
    });

    this.tables.forEach((table) => {
      table.renderRows();
    });

    this.requisitoInserindo = requisito.id;
  }

  cancelarNovo(requisito: Requisito) {
    this.limparNovo();

    requisito.requisitoMetrica.shift();

    this.tables.forEach((table) => {
      table.renderRows();
    });

    this.requisitoInserindo = null;
  }

  limparNovo() {
    this.metricaAtividade.length = 0;
    this.metricaComplexidade.length = 0;

    this.novaMetricaTipo = null;
    this.novaMetricaAtividade = null;
    this.novaMetricaComplexidade = null;
    this.novaMetricaTipoAtividade = null;

    this.requisitoInserindo = null;
  }

  habilitarAba() {
    this.validacaoService
      .validarRequisitos(this.estimativaId)
      .subscribe((res) => {
        let enabled = res;
        this.utilService.setBoolRequisitos(enabled);
        this.utilService.currentBoolRequisitos.subscribe((b) => (enabled = b));
      });
  }

  excluir(id: number) {
    this.loading = true;

    if (id > 0) {
      this.requisitoMetricaService.delete(id).subscribe(
        () => {
          this.toastr.mostrarMensagem(
            "sucesso",
            "Sucesso",
            "Registro excluído com sucesso"
          );

          this.recalcularFaturamento(this.estimativaId, "");

          this.redirect();
          this.carregarRequisitoMetrica(this.estimativaId);
        },
        (error) => {
          this.misc.processError(error, "Não foi possível excluir a métrica.");

          this.loading = false;
        }
      );
    }
  }

  excluirRequisito(id: number) {
    this.loading = true;

    if (id > 0) {
      this.requisitoService.delete(id).subscribe(
        () => {
          this.carregarRequisitoMetrica(this.estimativaId);

          this.toastr.mostrarMensagem(
            "sucesso",
            "Sucesso",
            "Registro excluído com sucesso"
          );
        },
        (error) => {
          this.misc.processError(
            error,
            "Não foi possível deletar o requisito solicitado."
          );

          this.loading = false;
        }
      );
    }
  }

  carregarRequisitoMetrica(estimativaId) {
    this.loading = true;
    this.requisitoService
      .getByEstimativaId(estimativaId)
      .subscribe(
        (requisitos) => {
          if (requisitos) {
            this.filtroTipo = null;
            this.filtroAtividade = null;
            this.filtroComplexidade = null;

            requisitos.items.map((it) => {
              it.requisitoMetrica.map((req) => {
                req.editarMetricaStatus = false;
              });
            });

            this.requisitos = requisitos.items;
            this.requisitosFiltrados = requisitos.items;
            this.requisitosFiltrados;

            this.redirectPosSave(true);

            this.calcularTotalGeral();

            this.habilitarAba();

            this.carregarFiltros();

          }
        },
        (error) => {
          this.misc.processError(error, "Erro carregando a lista de métricas.");
        }
      )
      .add(() => {
        this.loading = false;
      });
  }

  redirectPosSave(saved = false) {
    if (saved && this.clicked) {
      setTimeout(() => window.scrollTo(0, 100000), 0.001);
      saved = saved!;
      this.loading = false;
    }
    this.clicked = false;
  }

  carregarFiltros() {
    const metricas = this.requisitos.map((requisito) => {
      return requisito.requisitoMetrica;
    })
      .flat();

    this.listaFiltroTipo = metricas.map(metrica => {
      return metrica.metricaTipo;
    }).flat().filter((value, index, self) => {
      const tipo = self.find(p => p.id === value.id);
      return self.indexOf(tipo) === index;
    });

    this.listaFiltroAtividade = metricas.map(metrica => {
      return metrica.metricaAtividade;
    }).flat().filter((value, index, self) => {
      const atividade = self.find(p => p.id === value.id);
      return self.indexOf(atividade) === index;
    });

    this.listaFiltroComplexidade = metricas.map((metrica) => {
      return metrica.metricaComplexidade
    })
      .flat()
      .filter((value, index, self) => {
        const complexidade = self.find((p) => p.id === value.id);
        return self.indexOf(complexidade) === index;
      });
  }

  filtrarRequisitos() {
    this.requisitosFiltrados = JSON.parse(JSON.stringify(this.requisitos)).map(
      (requisito) => {
        requisito.requisitoMetrica = requisito.requisitoMetrica.filter(
          (metrica) => {
            let filtroTipo = true;
            let filtroAtividade = true;
            let filtroComplexidade = true;

            if (this.filtroTipo) {
              filtroTipo = metrica.metricaTipoId === this.filtroTipo.id;
            }

            if (this.filtroAtividade) {
              filtroAtividade = metrica.metricaAtividadeId === this.filtroAtividade.id;
            }

            if (this.filtroComplexidade) {
              filtroComplexidade = metrica.metricaComplexidadeId === this.filtroComplexidade.id;
            }

            return filtroTipo && filtroAtividade && filtroComplexidade;
          }
        );

        return requisito;
      }
    );

    this.calcularTotalGeral();
  }

  cancelarFiltro() {
    this.filtroTipo = null;
    this.filtroAtividade = null;
    this.filtroComplexidade = null;

    this.requisitosFiltrados = JSON.parse(JSON.stringify(this.requisitos));
    this.calcularTotalGeral();
  }

  calcularHoras(requisitoMetrica: RequisitoMetrica) {
    if (requisitoMetrica.qtde > 0 && requisitoMetrica) {

      let metricaTipoAtividadeFilter = this.metricaTipoAtividade.find(p =>
        p.idMetricaTipo === (requisitoMetrica.metricaTipo ? requisitoMetrica.metricaTipo.id : this.novaMetricaTipo.id) &&
        p.idMetricaAtividade === (requisitoMetrica.metricaAtividade ? requisitoMetrica.metricaAtividade.id : this.novaMetricaAtividade.id) &&
        p.idMetricaComplexidade === (requisitoMetrica.metricaComplexidade ? requisitoMetrica.metricaComplexidade.id : this.novaMetricaComplexidade.id));

      requisitoMetrica.hora = requisitoMetrica.qtde * metricaTipoAtividadeFilter.hora;

      if (!this.requisitoInserindo) {
        this.requisitoMetricaService.update(requisitoMetrica).subscribe(() => {
          this.habilitarAba();
        });
      }

      this.calcularTotalGeral();

    }

  }

  calcularTotalHoras(requisitoMetrica: RequisitoMetrica[]) {
    return requisitoMetrica.reduce((sum, el) => sum + +el.hora, 0);
  }

  calcularTotalQuantidade(requisitoMetrica: RequisitoMetrica[]) {
    return requisitoMetrica.reduce((sum, el) => sum + +el.qtde, 0);
  }

  calcularTotalGeral() {
    let totalQuantidade = 0;
    let totalHora = 0;

    this.requisitosFiltrados
      .map((r) => r.requisitoMetrica)
      .forEach((requisitoMetrica) => {
        totalQuantidade += this.calcularTotalQuantidade(requisitoMetrica);
        totalHora += this.calcularTotalHoras(requisitoMetrica);
      });

    this.totalHoras = totalHora;
    this.totalQuantidade = totalQuantidade;
  }

  recalcularFaturamento(estimativaId: number, mensagemConclusao: string) {
    this.faturamentoService.recalcularFaturamento(estimativaId).subscribe(
      (faturamento) => {
        if (mensagemConclusao !== "")
          this.toastr.mostrarMensagem("sucesso", "Sucesso", mensagemConclusao);
      },
      (error) => {
        this.misc.processError(error, "Não foi possível recalcular o pricing.");
      },
      () => {
        this.loading = false;
      }
    );
  }

  saveMetrica() {
    const requisito = this.requisitosFiltrados.find(
      (p) => p.id === this.requisitoInserindo
    );

    if (!requisito.requisitoMetrica[0].descricao) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção!",
        "Favor informar a descrição da métrica!"
      );
      return;
    }

    if (!this.novaMetricaTipo || this.novaMetricaTipo.id <= 0) {
      this.toastr.mostrarMensagem("aviso", "Atenção!", "Selecione um tipo!");
      return;
    }

    if (!this.novaMetricaAtividade || this.novaMetricaAtividade.id <= 0) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção!",
        "Selecione uma atividade!"
      );
      return;
    }

    if (!this.novaMetricaComplexidade || this.novaMetricaComplexidade.id <= 0) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção!",
        "Selecione uma complexidade!"
      );
      return;
    }

    if (
      !requisito.requisitoMetrica[0].qtde ||
      requisito.requisitoMetrica[0].qtde <= 0
    ) {
      this.toastr.mostrarMensagem(
        "aviso",
        "Atenção!",
        "A quantidade não pode ser menor ou igual a zero!"
      );
      return;
    }

    this.loading = true;

    const requisitoMetrica = new RequisitoMetrica();
    requisitoMetrica.metricaTipoId = this.novaMetricaTipo.id;
    requisitoMetrica.metricaAtividadeId = this.novaMetricaAtividade.id;
    requisitoMetrica.metricaComplexidadeId = this.novaMetricaComplexidade.id;
    requisitoMetrica.requisitoId = this.requisitoInserindo;
    requisitoMetrica.descricao = requisito.requisitoMetrica[0].descricao;
    requisitoMetrica.qtde = requisito.requisitoMetrica[0].qtde;
    requisitoMetrica.hora = requisito.requisitoMetrica[0].hora;

    this.requisitoMetricaService.create(requisitoMetrica).subscribe(
      (metrica) => {
        this.loading = false;
        this.toastr.mostrarMensagem(
          "sucesso",
          "Sucesso",
          "Registro incluído com sucesso"
        );

        this.recalcularFaturamento(this.estimativaId, "");

        requisito.requisitoMetrica[0] = metrica;
        requisito.requisitoMetrica[0].metricaAtividade?.metricaTipoAtividade?.map((item) => {
          item = this.novaMetricaTipoAtividade;
        });

        this.limparNovo();

        this.redirect();
        this.carregarRequisitoMetrica(this.estimativaId);
      },
      (error) => {
        this.misc.processError(
          error,
          "Não foi possível adicionar a métrica informada."
        );

        this.loading = false;
      }
    );
  }

  getMetricaAtividadeById(tipo: MetricaTipo) {
    this.metricaAtividade.length = 0;
    this.metricaComplexidade.length = 0;
    this.novaMetricaTipoAtividade = null;

    const atividadeFiltrado = this.metricaTipoAtividade.filter(
      (p) => p.idMetricaTipo === tipo.id
    );

    this.metricaAtividade = atividadeFiltrado.map((item) => {
      return item.metricaAtividade;
    });

    this.metricaAtividade = this.metricaAtividade.sort((a, b) => (a.nome < b.nome ? -1 : 1));

    this.metricaAtividade = this.metricaAtividade.filter(
      (value, index, self) => {
        const metricaAtividade = self.find((p) => p.id === value.id);

        return self.indexOf(metricaAtividade) === index;
      }
    );
  }

  getMetricaComplexidadeById(atividade: MetricaAtividade) {
    this.metricaComplexidade.length = 0;
    this.novaMetricaTipoAtividade = null;

    const complexidadeFiltrado = this.metricaTipoAtividade.filter(p =>
      p.idMetricaTipo === this.metricaTipo.find(m => m.id == p.idMetricaTipo).id &&
      p.idMetricaAtividade === atividade.id
    );

    this.metricaComplexidade = complexidadeFiltrado.map(item => {
      return item.metricaComplexidade;
    });

    this.metricaComplexidade = this.metricaComplexidade.sort((a, b) => (a.nome < b.nome ? -1 : 1));

    this.metricaComplexidade = this.metricaComplexidade.filter((value, index, self) => {
      const metricaComplexidade = self.find(p => p.id === value.id);

      return self.indexOf(metricaComplexidade) === index;
    });
  }

  getTipoAtividadeHora(complexidade: MetricaComplexidade) {
    this.novaMetricaTipoAtividade = this.metricaTipoAtividade.find(
      (p) =>
        p.idMetricaTipo === this.novaMetricaTipo.id &&
        p.idMetricaAtividade === this.novaMetricaAtividade.id &&
        p.idMetricaComplexidade === complexidade.id
    );

    const requisitoInserindo = this.requisitosFiltrados.find((p) => p.id === this.requisitoInserindo);

    requisitoInserindo.requisitoMetrica[0].metricaAtividade?.metricaTipoAtividade?.map((item) => {
      item = this.novaMetricaTipoAtividade;
    });

    requisitoInserindo.requisitoMetrica[0].hora = requisitoInserindo.requisitoMetrica[0].qtde * this.novaMetricaTipoAtividade.hora;
  }

  editTipoAtividadeHora(requisitoMetrica: RequisitoMetrica) {
    let metricaTipoAtividade = this.metricaTipoAtividade.find(
      (p) =>
        p.idMetricaTipo === requisitoMetrica.metricaTipo.id &&
        p.idMetricaAtividade === requisitoMetrica.metricaAtividade.id &&
        p.idMetricaComplexidade === requisitoMetrica.metricaComplexidade.id
    );

    requisitoMetrica.hora = metricaTipoAtividade?.hora;
    requisitoMetrica.hora = requisitoMetrica.qtde * metricaTipoAtividade?.hora;

  }

  openDialog(clicked = false): void {
    const dialogRef = this.dialog.open(RequisitoFormComponent, {
      width: "600px",
      data: { estimativaId: this.estimativaId },
      panelClass: "default-dialog-container",
    });

    dialogRef.afterClosed().subscribe(() => {
      this.clicked = true;
      this.carregarRequisitoMetrica(this.estimativaId);
    });
  }

  editarNome(requisito: Requisito) {
    this.idAtual = requisito.id;
    this.nomeRequisitoEditado = requisito.nome;
    this.editarNomeReq = true;
  }

  editarMetrica(requisitoMetrica: RequisitoMetrica) {
    requisitoMetrica.requisitoMetricaOriginal = JSON.parse(
      JSON.stringify(requisitoMetrica)
    );

    requisitoMetrica.editarMetricaStatus = true;

    requisitoMetrica.metricaTipo = this.metricaTipo.find(
      (p) => p.id == requisitoMetrica.metricaTipoId
    );

    this.getMetricaAtividadeById(this.metricaTipo.find(
      (p) => p.id == requisitoMetrica.metricaTipoId
    ));

    requisitoMetrica.metricaAtividade = this.metricaAtividade.find(
      (p) => p.id == requisitoMetrica.metricaAtividadeId
    );

    this.getMetricaComplexidadeById(requisitoMetrica.metricaAtividade);

    requisitoMetrica.metricaComplexidade = this.metricaComplexidade.find(
      (p) => p.id == requisitoMetrica.metricaComplexidadeId
    );

  }

  salvarMetricaEditada(requisitoMetrica: RequisitoMetrica) {
    this.loading = true;

    requisitoMetrica.metricaAtividade.metricaTipoAtividade.map((m) => {
      m.idMetricaTipo = m.id
    });
    // requisitoMetrica.metricaTipoAtividade.idMetricaAtividade = requisitoMetrica.metricaTipoAtividade.metricaAtividade.id
    // requisitoMetrica.metricaTipoAtividade.idMetricaComplexidade = requisitoMetrica.metricaTipoAtividade.metricaComplexidade.id

    requisitoMetrica.metricaTipoId = requisitoMetrica.metricaTipo.id
    requisitoMetrica.metricaAtividadeId = requisitoMetrica.metricaAtividade.id
    requisitoMetrica.metricaComplexidadeId = requisitoMetrica.metricaComplexidade.id

    this.requisitoMetricaService
      .update(requisitoMetrica)
      .subscribe(() => {
        requisitoMetrica.editarMetricaStatus = false;

        requisitoMetrica.requisitoMetricaOriginal = null;

        this.calcularTotalGeral();
      })
      .add(() => {
        this.toastr.mostrarMensagem(
          "sucesso",
          "Sucesso",
          "Registro alterado com sucesso"
        );

        this.loading = false;
      });
  }

  saveNome(requisito: Requisito) {
    this.loading = true;
    requisito.nome = this.nomeRequisitoEditado;

    this.requisitoService.update(requisito).subscribe(() => {
      this.editarNomeReq = false;
      this.loading = false;
    });
    this.nomeRequisitoEditado = null;
  }

  cancelar(requisitoMetrica: RequisitoMetrica = null) {
    this.idAtual = null;
    this.nomeRequisitoEditado = null;
    this.editarNomeReq = false;

    if (requisitoMetrica) {
      this.recarregarMetricaOriginal(requisitoMetrica);
    }

    this.calcularTotalGeral();
  }

  recarregarMetricaOriginal(requisitoMetrica: RequisitoMetrica) {
    requisitoMetrica.editarMetricaStatus = false;

    requisitoMetrica.descricao = requisitoMetrica.requisitoMetricaOriginal.descricao;

    requisitoMetrica.hora = requisitoMetrica.requisitoMetricaOriginal.hora;
    requisitoMetrica.qtde = requisitoMetrica.requisitoMetricaOriginal.qtde;

    requisitoMetrica.metricaTipo = this.metricaTipo.find(p => p.id == requisitoMetrica.requisitoMetricaOriginal.metricaTipoId);

    this.getMetricaAtividadeById(requisitoMetrica.metricaTipo);
    requisitoMetrica.metricaAtividade = this.metricaAtividade.find(p => p.id == requisitoMetrica.requisitoMetricaOriginal.metricaAtividadeId);

    this.getMetricaComplexidadeById(requisitoMetrica.metricaAtividade);
    requisitoMetrica.metricaComplexidade = this.metricaComplexidade.find(p => p.id == requisitoMetrica.requisitoMetricaOriginal.metricaComplexidadeId);

    requisitoMetrica.requisitoMetricaOriginal = null;
  }
}
